import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MatCardModule } from '@angular/material/card';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { TrackingComponent } from './admin/pages/tracking/tracking.component';
import { TrackingDetailsComponent } from './admin/pages/tracking-details/tracking-details.component';
import { MapComponent } from './admin/shared/map/map.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { MessageDialogComponent } from './admin/shared/message-dialog/message-dialog.component';
import { FooterComponent } from './admin/shared/footer/footer.component';
import { ShareCsvDialogComponent } from './admin/shared/share-csv-dialog/share-csv-dialog.component';
import { ApplinkComponent } from './admin/shared/applink/applink.component';

@NgModule({
  declarations: [
    AppComponent,
    TrackingComponent,
    TrackingDetailsComponent,
    MapComponent,
    MessageDialogComponent,
    FooterComponent,
    ShareCsvDialogComponent,
    ApplinkComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    RouterModule,
    MatCardModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    MatProgressBarModule,
    GoogleMapsModule,
    MatExpansionModule,
    MatProgressSpinnerModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
